import React from "react";
import { Link } from "react-router-dom";
import { eventsData } from "./eventsData";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ScrollAdd from "../components/ScrollAdd";
import "./UpcomingEvent.css";

const UpcomingEvent = () => {
  return (
    <>
      
      <div className="upcoming-events-page">
        <div className="events-hero">
          <h1 className="hero-title">Upcoming Summer Camps 2026</h1>
          <p className="hero-subtitle">
            Explore the best, most immersive summer experiences for kids and teens in Hyderabad.
            From rural traditions to cutting-edge AI technology.
          </p>
        </div>

        <div className="cards-container">
          <div className="events-grid">
            {eventsData.map((event) => (
              <Link to={`/event/${event.id}`} key={event.id} className="event-card-link">
                <div className="event-card">
                  <div className="card-image-wrapper">
                    <img src={event.image} alt={event.title} className="card-image" />
                    <div className="card-badge">{event.ageGroup}</div>
                  </div>
                  
                  <div className="card-content">
                    <h3 className="card-title">{event.title}</h3>
                    
                    <div className="card-info">
                      <div className="info-row">
                        <i className="fas fa-calendar-alt"></i>
                        <span>{event.dates}</span>
                      </div>
                      <div className="info-row truncate">
                        <i className="fas fa-map-marker-alt"></i>
                        <span>{event.venue}</span>
                      </div>
                    </div>

                    <div className="card-footer">
                      <span className="card-fee">{event.fee}</span>
                      <span className="learn-more">
                        View Details <i className="fas fa-arrow-right"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
   
    </>
  );
};

export default UpcomingEvent;